import {PIXI} from '@colonist/pixi'
import {UIGameTimedAnimation} from './animation/UIGameTimedAnimation'
import {SectionBgView} from './SectionBgView'

export class CooldownAnimation extends UIGameTimedAnimation {
    protected readonly forceEnableAnimation: boolean = true
    protected readonly viewToAnimate: PIXI.Container
    private phase = 0
    private readonly mask: PIXI.Graphics
    private readonly textureToMask: PIXI.Sprite

    constructor(viewToAnimate: SectionBgView, duration: number, textureToMask: PIXI.Texture) {
        super(duration)
        this.viewToAnimate = viewToAnimate
        this.textureToMask = PIXI.Sprite.from(textureToMask)
        this.mask = this.createMask(viewToAnimate)
        viewToAnimate.addChild(this.textureToMask)
        viewToAnimate.addChild(this.mask)
    }

    private createMask(target: SectionBgView): PIXI.Graphics {
        const mask = new PIXI.Graphics()
        mask.position.set(target.width / 2, target.height / 2)
        this.textureToMask.mask = mask
        return mask
    }

    // https://pixijs.com/examples/advanced/spinners
    updateAnimation(deltaTime: number, elapsedMS: number) {
        this.updateCircularPhase()
        this.drawCooldownProgressMask()
    }

    private updateCircularPhase() {
        this.phase = (this.totalElapsedMS * (Math.PI * 2)) / this.duration
        this.phase = Math.min(this.phase, Math.PI * 2)
    }

    private drawCooldownProgressMask() {
        const angleStart = -Math.PI / 2
        const angleEnd = this.phase + angleStart
        const radius = 50
        const x1 = Math.cos(angleStart) * radius
        const y1 = Math.sin(angleStart) * radius

        this.mask.clear()
        this.mask.lineStyle(2, 0xff0000, 1)
        this.mask.beginFill(0xff0000, 1)
        this.mask.moveTo(0, 0)
        this.mask.lineTo(x1, y1)
        this.mask.arc(0, 0, radius, angleStart, angleEnd, false)
        this.mask.lineTo(0, 0)
        this.mask.endFill()
    }

    resetToDefaultState(): void {
        this.viewToAnimate.removeChild(this.mask, this.textureToMask)
    }
}
